import { render, staticRenderFns } from "./StudentExplain.vue?vue&type=template&id=4fcd0b19&scoped=true"
import script from "./StudentExplain.vue?vue&type=script&lang=js"
export * from "./StudentExplain.vue?vue&type=script&lang=js"
import style0 from "./StudentExplain.vue?vue&type=style&index=0&id=4fcd0b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd0b19",
  null
  
)

export default component.exports